var constants = require('../constants');
var initialState = require('../../initialState');

var featuredPlacement = function(state, action) {
  switch (action.type) {
	  case constants.SET_FEATURED_PLACEMENT:
        return action.featuredPlacement || initialState.featuredPlacement;
      case constants.RESET_FEATURED_PLACEMENT:
        return initialState.featuredPlacement;
	  default: return state || initialState.featuredPlacement;
  }
}

module.exports = featuredPlacement;



// WEBPACK FOOTER //
// ./src/common/modules/conditions/reducers/featuredPlacement.js